export default __webpack_public_path__ + "locales/nl/Article.json?hash=2b833f829b35844133e79e03c12b9a35";